(ns profile.specs
  (:require [cljs.spec.alpha :as s]))

(s/def ::name string?)
(s/def ::first-name string?)
(s/def ::last-name string?)
(s/def ::age string?)
(s/def ::retirement-age (s/nilable string?))
(s/def ::retired boolean?)
(s/def ::children-count string?)
(s/def ::phone (s/nilable string?))
(s/def ::full-address (s/nilable string?))
(s/def ::dob string?)
(s/def ::marital-status (s/nilable string?))
(s/def ::occupation (s/nilable string?))
(s/def ::employer (s/nilable string?))
(s/def ::street (s/nilable string?))
(s/def ::city (s/nilable string?))
(s/def ::state (s/nilable string?))
(s/def ::postal-code (s/nilable string?))
(s/def ::photo-url (s/nilable string?))
(s/def ::spouse (s/nilable (s/keys :opt-un [::dob
                                            ::name
                                            ::first-name
                                            ::last-name
                                            ::retirement-age
                                            ::retired
                                            ::occupation
                                            ::employer])))
(s/def ::child (s/keys :opt-un [::dob
                                ::first-name
                                ::last-name]))
(s/def ::children (s/coll-of ::child))
(s/def ::personal-information (s/nilable (s/keys :req-un [::name]
                                                 :opt-un [::dob
                                                          ::retirement-age
                                                          ::retired
                                                          ::spouse
                                                          ::marital-status
                                                          ::children
                                                          ::phone
                                                          ::occupation
                                                          ::employer
                                                          ::street
                                                          ::city
                                                          ::state
                                                          ::postal-code
                                                          ::photo-url
                                                          ::full-address])))


(s/def ::context #{:view-profile
                   :manage-priorities
                   :edit-personal-information
                   :edit-insurance
                   :edit-risk-survey
                   :edit-assets-and-liabilities
                   :edit-estate-and-tax
                   :edit-expenses
                   :edit-income})


(s/def ::profile (s/keys :opt-un [::context]))

(s/def ::script-loaded? boolean?)
(s/def ::uploadcare (s/keys ::opt-un [::script-loaded?]))

